export default function Logo({ onClick }) {
    return (
        <button
            onClick={onClick}
            className="flex items-center"
            data-testid="logo-button"
            aria-label="MasterClaus — voltar ao topo"
        >
            <img
                src="/masterclaus-logo.png"
                alt="MasterClaus — Investigação Comercial"
                className="h-12 w-auto"
                style={{ mixBlendMode: "screen" }}
                data-testid="logo-image"
            />
        </button>
    );
}
